import { useEffect, useState } from "react";

export function useIsMobile() {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkIsMobile = () => {
			const userAgent = window.navigator.userAgent.toLowerCase();
			const isMobileDevice =
				/mobi|android|iphone|ipad|ipod|windows phone|blackberry|iemobile|opera mini/i.test(
					userAgent,
				) ||
				(window.innerWidth <= 768 && "ontouchstart" in window) ||
				navigator.maxTouchPoints > 1;

			setIsMobile(isMobileDevice);
		};

		checkIsMobile();

		window.addEventListener("resize", checkIsMobile);

		return () => window.removeEventListener("resize", checkIsMobile);
	}, []);

	return isMobile;
}
